import apiService from "./api";

const categoryService = {
  getCategories() {
    return apiService.get("/categories");
  },
  createCategory(categoryData) {
    return apiService.post("/categories", categoryData);
  },
  updateCategory(categoryId, categoryData) {
    return apiService.put(`/categories/${categoryId}`, categoryData);
  },
  deleteCategory(categoryId) {
    return apiService.delete(`/categories/${categoryId}`);
  },
  deleteCategoryImage(categoryId) {
    return apiService.delete(`/categories/category-image-delete/${categoryId}`);
  },
  uploadCategoryImage(formData) {
    return apiService.post("/gallery", formData);
  },
  setMainGroupMeal(categoryData) {
    return apiService.post("/categories/set-main-group-meal", categoryData);
  },
  setAttachment(categoryData) {
    return apiService.post("/categories/set-prilog", categoryData);
  },
  // Telo: { id, exclude_from_package_count: 0|1 }
  setExcludeFromPackageCount(categoryData) {
    return apiService.post("/categories/set-exclude-from-package-count", categoryData);
  },
  // Guest categories
  getCategoriesGuest(params) {
    return apiService.get("/categories-guest", params);
  },
};

export default categoryService;
